<template>
  <page-layout
    title="定价设置"
    class="p-PricingStrategy"
  >

    <div class="p-PricingStrategy-header">
      隐私设置
    </div>
    <div class="p-PricingStrategy-settinghidename">
      <p>
        秒配匹配结果隐藏公司名
        <el-switch
          v-model="value"
          active-color="#13ce66"
          @change="switchChange"
        >
        </el-switch>
      </p>
      <p>
        *开启后秒配匹配结果将隐藏公司名，采购商下单后方显示公司名
      </p>
    </div>
    <div class="p-PricingStrategy-header">
      阶梯价
    </div>

    <div class="p-PricingStrategy-tiered-pricing">
      <price-card
        v-for="(item, index) in tieredPricings"
        :key="index"
        :price-data="item"
        :get-datas="getShareStepPlanListAsync"
        :show-delete="tieredPricingsWithGuid.length > 1"
        class="p-PricingStrategy-tiered-pricing-item"
      >
      </price-card>

      <div
        class="p-PricingStrategy-tiered-pricing-item addnew"
        @click="addTieredPricing"
        v-show="showAddCard"
      >
        <p>
          <i class="iconfont icon-add_round"></i>
        </p>
        新建方案
      </div>
    </div>

    <div class="p-PricingStrategy-header clearfix mt20">
      定价帮助
    </div>
    <div class="p-PricingStrategy-title">
      <h4>
        最终售价公式：
      </h4>
      <p>
        未税价*发票税率*管道阶梯价=最终售价（结算价）
      </p>
      <h4>
        例：
      </h4>
      <p>
        假设您在库存定价将物料LM358的未税价设为：1元，发票税率设为： 3%，管道阶梯价方案二设为：10+,1.4倍。销售10片LM358的价格为：1*10*1.03*1.4=14.1316元
      </p>

      <h4 class="tip">定价规则图解:</h4>

      <div class="p-PricingStrategy-title-bg">

      </div>
    </div>
  </page-layout>
</template>
<script>
import PriceCard from './PriceCard';
import { httpPost, httpGet } from '../../assets/scripts/http';
import PageLayout from '../PageLayout';
export default {
  name: 'PricingStrategy',
  data() {
    return {
      tieredPricings: [],
      value: false
    };
  },
  components: {
    PriceCard,
    PageLayout
  },
  created() {
    this.getShareStepPlanListAsync();
    this.PostOpenBomCompanyNameAsync();
  },
  computed: {
    tieredPricingsWithGuid() {
      return this.tieredPricings.filter(item => item.StepPlanGuid);
    },
    showAddCard() {
      return !this.tieredPricings.find(item => item.IsEdit);
    }
  },
  methods: {
    addTieredPricing() {
      // 最多10个阶梯价
      if (this.tieredPricings.length >= 10) {
        return this.$erroMess('最多允许保存10个方案');
      }
      // id轮排
      let StepPlanId = this.tieredPricings.length + 1;
      const StepPlanIdArray = this.tieredPricings
        .map(item => item.StepPlanId)
        .sort((a, b) => b - a);
      for (let index = 1; index < StepPlanIdArray[0]; index++) {
        const HasStepPlanId = StepPlanIdArray.find(item => item === index);
        if (!HasStepPlanId) {
          StepPlanId = index;
          break;
        }
      }
      this.tieredPricings.push({
        IsEdit: true,
        StepPlanId,
        StepPlanSummary: '',
        StepPlanPrices: [
          {
            Qty: '',
            PriceMultiple: ''
          }
        ]
      });
    },
    async getShareStepPlanListAsync() {
      return httpGet('shareStock/getShareStepPlanListAsync').then(res => {
        if (res.Code === 0) {
          const Datas = res.Data || [];
          for (const item of Datas) {
            item.IsEdit = false;
          }
          this.tieredPricings = Datas;
        }
      });
    },
    PostOpenBomCompanyNameAsync() {
      httpGet('shareStock/PostOpenBomCompanyNameAsync').then(res => {
        if (res.Code === 0) {
          this.value = !res.Data;
        }
      });
    },
    switchChange(value) {
      httpPost('shareStock/PostOpenOrClosedBomCompanyNameAsync', {
        IsOpen: !value
      });
    }
  }
};
</script>

<style lang="scss">
.p-PricingStrategy {
  .mt20 {
    margin-top: 20px;
  }
  .p-PricingStrategy-title {
    position: relative;
    font-size: 12px;
    padding-left: 10px;
    padding-top: 10px;
    line-height: 26px;
    .tip {
      padding: 10px 0;
      font-size: 12px;
    }
    .p-PricingStrategy-title-bg {
      width: 554px;
      height: 166px;
      background: url('./imgs/pricing-rule@2x.png');
      background-size: 100% 100%;
    }
  }
  .p-PricingStrategy-header {
    line-height: 30px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.65);
    font-weight: bold;
    background-color: #e6e6e6;
    padding-left: 10px;
  }
  .save-button {
    margin-left: 125px;
  }
  .p-PricingStrategy-table {
    width: 300px;
  }
  .p-PricingStrategy-row {
    display: flex;
    font-size: 12px;
    line-height: 30px;
    .cell {
      text-align: center;
      input {
        width: 40px;
        outline: none;
      }
    }
  }
  .cell-input {
    width: 30px;
  }

  .znl-component-input .el-input__inner {
    padding-left: 5px;
  }

  .p-PricingStrategy-settinghidename {
    padding: 10px 20px;
    line-height: 30px;
    font-size: 14px;
    .znl-switch {
      margin-left: 20px;
    }
    p {
      &:last-child {
        font-size: 12px;
        color: #666;
      }
    }
  }

  .p-PricingStrategy-tiered-pricing {
    .p-PricingStrategy-tiered-pricing-item {
      margin-right: 20px;
      margin-top: 10px;
      &.addnew {
        width: 200px;
        height: 307px;
        border: 1px solid #e6e6e6;
        padding: 10px;
        box-sizing: border-box;
        display: inline-block;
        background-color: #fff;
        text-align: center;
        color: #ced0da;
        font-size: 16px;
        padding-top: 100px;
        .iconfont {
          font-size: 50px;
        }
        &:hover {
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}
</style>
